import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form';
import { toFromDates } from '../components/Common/cleanDates';

import {
  REQUEST_BASE_USER,
  FETCH_BASE_USER_SUCCESS,
  FETCH_BASE_USER_FAILURE,
  REQUEST_BASE_USER_DETAIL,
  FETCH_BASE_USER_DETAIL_SUCCESS,
  FETCH_BASE_USER_DETAIL_FAILURE,
  REQUEST_MOBILE_USERS,
  FETCH_MOBILE_USERS_SUCCESS,
  FETCH_MOBILE_USERS_FAILURE,
  SELECT_CURRENT_USER,
  RESET_CURRENT_USER,
  REQUEST_USER_GROUPS,
  FETCH_USER_GROUPS_SUCCESS,
  FETCH_USER_GROUPS_FAILURE,
  REQUEST_PERMISSIONS,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  EDIT_USER_DETAIL,
  EDIT_USER_DETAIL_SUCCESS,
  EDIT_USER_DETAIL_FAILURE,
  SELECT_CURRENT_GROUP,
  RESET_CURRENT_USER_GROUP,
  REQUEST_GROUP_DETAIL,
  FETCH_GROUP_DETAIL_SUCCESS,
  FETCH_GROUP_DETAIL_FAILURE,
  EDIT_GROUP_DETAIL,
  EDIT_GROUP_DETAIL_SUCCESS,
  EDIT_GROUP_DETAIL_FAILURE,
  CREATE_GROUP_DETAIL,
  CREATE_GROUP_DETAIL_SUCCESS,
  CREATE_GROUP_DETAIL_FAILURE,
  RESET_USER_DETAIL,
  CREATE_USER_DETAIL,
  CREATE_USER_DETAIL_SUCCESS,
  CREATE_USER_DETAIL_FAILURE,
  EDIT_PASSWORD,
  EDIT_PASSWORD_SUCCESS,
  EDIT_PASSWORD_FAILURE,
  RESET_PASSWORD,
  CHECK_PASSWORD,
  CHECK_PASSWORD_SUCCESS,
  CHECK_PASSWORD_FAILURE,
  CLEAR_CHECK_PASSWORD,
  CHECK_PERMISSIOIN,
  CHECK_PERMISSIOIN_SUCCESS,
  CHECK_PERMISSIOIN_FAILURE,
  REQUEST_ACTION_LOG,
  FETCH_ACTION_LOG_SUCCESS,
  FETCH_ACTION_LOG_FAILURE,
  REQUEST_ACTION_LOG_BY_FILTER,
  ACTION_LOG_FILTER_SUCCESS,
  ACTION_LOG_FILTER_FAILURE,
  GRAB_MOBILE_USER_ID,
  REQUEST_USERNAME,
  REQUEST_USERNAME_SUCCESS,
  REQUEST_USERNAME_FAILURE,
  CLEAR_USERNAME_DATA,
  SET_SELECTED_BUSINESSUSER,
} from './type';

import {
  BASE_USER_URL,
  ACTION_LOG_FILTER_URL,
  USERNAME_URL,
  BUSINESS_USERS_URL,
  BUSINESS_USER_CONVERT,
} from './url';
import { ROOT_URL } from './root_url';

import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchBaseUsers() {
  return dispatch => {
    dispatch(requestBaseUsers());
    return axios.get(BASE_USER_URL + 'users/',
    // return axios.post(ROOT_URL + 'v1/dashboard/salescsv', {},
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchBaseUsersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchBaseUsersFailure(err));
      });
  };
}

export function fetchBusinessUsersAPI(params, cb) {
  //serving a feature of Ecity only
  //fetching business users
  const generateParams = params ? {
    update_time__gt: params.fromDate, update_time__lt: params.toDate
  } : {};
  axios.get(BUSINESS_USERS_URL, {
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
    params: generateParams,
  })
    .then( res => {
      cb({ businessUsersTable: {
        rows: res.data,
      }});
    })
    .catch( err => {
    })
}

export function setSelectedBusinessUser(selectedUser) {
  //associates with Ecity business user feature
  return dispatch => {
    dispatch({
      type: SET_SELECTED_BUSINESSUSER,
      payload: selectedUser,
    })
  }
}

export function handleEditUserConfirm(userDetail) {
  //serves business user feature of Ecity


  if (userDetail.is_process && userDetail.is_process.value) {
    userDetail.is_process = userDetail.is_process.value;
  }
  if (userDetail.gender && userDetail.gender.value) {
    userDetail.gender = userDetail.gender.value;
  }  if (userDetail.is_retailer && userDetail.is_retailer.value) {
    userDetail.is_retailer = userDetail.is_retailer.value;
  }  if (userDetail.business_type && userDetail.business_type.value) {
    userDetail.business_type = userDetail.business_type.value;
  } 

  const cleanData = {
    ...userDetail,
    // is_process,
    // gender,
    // is_retailer,
    // business_type,
    // is_process: typeof userDetail.is_process === "object" ? userDetail.is_process.value : userDetail.is_process,
    // gender: typeof userDetail.gender === "object" ? userDetail.gender.value : userDetail.gender,
    // is_retailer: typeof userDetail.is_retailer === "object" ? userDetail.is_retailer.value : userDetail.is_retailer,
    // business_type: typeof userDetail.business_type === "object" ? userDetail.business_type.value : userDetail.business_type,
  };
  const config = {
    url: `${BUSINESS_USERS_URL}${userDetail.user_id}`,
    data: cleanData,
    method: 'PUT',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token')}
  };
  return axios(config);
}

export function verifyBusinessUser(userDetail) {
  //serves business user feature of Ecity
  const config = {
    url: `${BUSINESS_USER_CONVERT}${userDetail.user_id}`,
    method: 'POST',
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token')}
  };
  return axios(config);
}

export function requestBaseUsers() {
  return {
    type: REQUEST_BASE_USER,
  };
}

export function fetchBaseUsersSuccess(baseUsers) {
  return {
    type: FETCH_BASE_USER_SUCCESS,
    payload: baseUsers,
  };
}

export function fetchBaseUsersFailure(error) {
  return {
    type: FETCH_BASE_USER_FAILURE,
    payload: error,
  };
}

function fetchMobileUsersSuccess(response) {
  return {
    type: FETCH_MOBILE_USERS_SUCCESS,
    payload: response,
  };
}

function fetchMobileUsersFailure(error) {
  return {
    type: FETCH_MOBILE_USERS_FAILURE,
    payload: error,
  };
}

export function fetchMobileUsers(currentPage, limit, customerNo, firstName, lastName, email, phone, active) {
  if (!limit) { limit = 'all'; }
  currentPage = currentPage + 1;
  const url = `${BASE_USER_URL}mobile-paginator`;
  return (dispatch) => {
    dispatch({ type: REQUEST_MOBILE_USERS });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        page: currentPage,
        limit: limit,
        CustomerNum: customerNo,
        FirstName: firstName,
        LastName: lastName,
        email: email,
        phone,
        IsActive: active,
      },
    }).then((response) => {
      dispatch(fetchMobileUsersSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchMobileUsersFailure(err));
    });
  };
}

export function fetchUserDetail(user_id) {
    return dispatch => {
        dispatch(
          {
              type: REQUEST_BASE_USER_DETAIL
          }
        );
        return axios.get(BASE_USER_URL + 'users/' + user_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchUserDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchUserDetailFailure(err));
            });
    }
}

export function fetchUserDetailSuccess(baseUserDetail) {
    return {
        type: FETCH_BASE_USER_DETAIL_SUCCESS,
        payload: baseUserDetail
    };
}

export function fetchUserDetailFailure(error) {
    return {
        type: FETCH_BASE_USER_DETAIL_FAILURE,
        payload: error
    };
}

export function selectCurrentUser(user_id) {
    return {
        type: SELECT_CURRENT_USER,
        payload: user_id
    };
}

export function resetCurrentUser() {
    return {
      type: RESET_CURRENT_USER
    }
}

export function fetchGroups() {
    return dispatch => {
        dispatch(
          {
              type: REQUEST_USER_GROUPS
          }
        );
        return axios.get(BASE_USER_URL + 'groups/',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchGroupsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchGroupsFailure(err));
            });
    }
}

export function fetchGroupsSuccess(groups) {
    return {
        type: FETCH_USER_GROUPS_SUCCESS,
        payload: groups
    };
}

export function fetchGroupsFailure(error) {
    return {
        type: FETCH_USER_GROUPS_FAILURE,
        payload: error
    };
}

export function fetchGroupDetail(group_id) {
    return dispatch => {
        dispatch(
          {
              type: REQUEST_GROUP_DETAIL
          }
        );
        return axios.get(`${BASE_USER_URL}groups/${group_id}/`,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchGroupDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchGroupDetailFailure(err));
            });
    }
}

export function fetchGroupDetailSuccess(groupDetail) {
    return {
        type: FETCH_GROUP_DETAIL_SUCCESS,
        payload: groupDetail
    };
}

export function fetchGroupDetailFailure(error) {
    return {
        type: FETCH_GROUP_DETAIL_FAILURE,
        payload: error
    };
}

export function selectCurrentGroup(group_id) {
    return {
        type: SELECT_CURRENT_GROUP,
        payload: group_id
    };
}

export function resetCurrentGroup() {
    return {
      type: RESET_CURRENT_USER_GROUP
    }
}

export function fetchPermissions() {
    return dispatch => {
        dispatch(
          {
              type: REQUEST_PERMISSIONS
          }
        );
        return axios.get(BASE_USER_URL + 'permissions/',
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(fetchPermissionsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchPermissionsFailure(err));
            });
    }
}

export function fetchPermissionsSuccess(permissions) {
    return {
        type: FETCH_PERMISSIONS_SUCCESS,
        payload: permissions
    };
}

export function fetchPermissionsFailure(error) {
    return {
        type: FETCH_PERMISSIONS_FAILURE,
        payload: error
    };
}

export function resetUserDetail() {
   return {
     type: RESET_USER_DETAIL
   }
}
export function editUserPermission(permissions) {
  const formattedPermissions = [];
  for (let i = 0; i < permissions.length; i++) {
    formattedPermissions.push({ codename: permissions[i] });
  }
  localStorage.setItem('userPermissions', JSON.stringify(formattedPermissions));
}

export function createUserDetail({
  email,
  username,
  password,
  FirstName,
  LastName,
  passcode,
  IsOfficeOnly,
}, permissions, groups) {
  console.log("fistname", FirstName, LastName)
    return dispatch => {
        dispatch(
          {
                type: CREATE_USER_DETAIL
          }
        );
        return axios.post(BASE_USER_URL + 'register/',
            {
                username,
                email,
                password,
                groups,
                permissions,
                FirstName,
                LastName,
                passcode,
                IsOfficeOnly,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createUserDetailSuccess(response));
              // dispatch(editUserPermission(permissions));
              browserHistory.push('/userManagement');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createUserDetailFailure(err));
            });
    }
}

export function createUserDetailSuccess(response) {
    return {
        type: CREATE_USER_DETAIL_SUCCESS,
        payload: response
    };
}

export function createUserDetailFailure(error) {
    return {
        type: CREATE_USER_DETAIL_FAILURE,
        payload: error
    };
}

export function editUserDetail({
  email,
  id,
  username,
  FirstName,
  LastName,
  passcode,
  IsOfficeOnly,
}, permissions, groups, type) {
    return dispatch => {
        dispatch(
          {
                type: EDIT_USER_DETAIL
          }
        );
        return axios.put(`${BASE_USER_URL}users/${id}/`,
            {
                username,
                email,
                groups,
                permissions,
                FirstName,
                LastName,
                passcode,
                IsOfficeOnly,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editUserDetailSuccess(response));
              //dispatch(editUserPermission(permissions));
              if(type == 1){
                browserHistory.push('/userManagement');
              }
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editUserDetailFailure(err));
            });
    }
}

export function editUserDetailSuccess(response) {
    return {
        type: EDIT_USER_DETAIL_SUCCESS,
        payload: response
    };
}

export function editUserDetailFailure(error) {
    return {
        type: EDIT_USER_DETAIL_FAILURE,
        payload: error
    };
}

export function editPassword({
  password,
  new_password,
  renew_password,
  BaseUser_id,
}) {
    return dispatch => {
        dispatch(
          {
                type: EDIT_PASSWORD
          }
        );
        return axios.put(`${BASE_USER_URL}password/${BaseUser_id}/`,
            {
                password,
                new_password,
                renew_password,
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editPasswordSuccess(response));
              if(type == 1){
                browserHistory.push('/userManagement');
              }
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editPasswordFailure(err));
            });
    }
}

export function editPasswordSuccess(response) {
    return {
        type: EDIT_PASSWORD_SUCCESS,
        payload: response
    };
}

export function editPasswordFailure(error) {
    return {
        type: EDIT_PASSWORD_FAILURE,
        payload: error
    };
}

export function editGroupDetail(id, { name }, permissions) {
    return dispatch => {
        dispatch(
          {
                type: EDIT_GROUP_DETAIL
          }
        );
        return axios.put(`${BASE_USER_URL}groups/${id}/`,
            {
                name,
                permissions
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editGroupDetailSuccess(response));
              browserHistory.push('/groupManagement');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editGroupDetailFailure(err));
            });
    }
}

export function editGroupDetailSuccess(response) {
    return {
        type: EDIT_GROUP_DETAIL_SUCCESS,
        payload: response
    };
}

export function editGroupDetailFailure(error) {
    return {
        type: EDIT_GROUP_DETAIL_FAILURE,
        payload: error
    };
}

export function createGroupDetail({
  name
}, permissions) {
    return dispatch => {
        dispatch(
          {
                type: CREATE_GROUP_DETAIL
          }
        );
        return axios.post(BASE_USER_URL + 'groups/',
            {
                name,
                permissions
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createGroupDetailSuccess(response));
              browserHistory.push('/groupManagement');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createGroupDetailFailure(err));
            });
    }
}

export function createGroupDetailSuccess(response) {
    return {
        type: CREATE_GROUP_DETAIL_SUCCESS,
        payload: response
    };
}

export function createGroupDetailFailure(error) {
    return {
        type: CREATE_GROUP_DETAIL_FAILURE,
        payload: error
    };
}


export function resetPassword() {
    return {
        type: RESET_PASSWORD
    };
}

export function checkPassword(password) {
  return dispatch => {
    dispatch({ type: CHECK_PASSWORD });
    return axios.post(BASE_USER_URL+'checkpassword/', {password},
      {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      })
      .then(response => {
        dispatch(checkPasswordSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(checkPasswordFailure(err));
      });
  }
}

function checkPasswordSuccess(data) {
  return {
    type: CHECK_PASSWORD_SUCCESS,
    payload: data
  }
}

function checkPasswordFailure(error) {
  return {
    type: CHECK_PASSWORD_FAILURE,
    payload: error
  }
}

export function clearCheckPassword() {
  return {
    type: CLEAR_CHECK_PASSWORD,
  }
}

export function checkPermission(username, password) {
  return dispatch => {
    dispatch({type: CHECK_PERMISSIOIN});
    return axios.post(BASE_USER_URL + 'manager/',
        {
          username,
          password
        },
        {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
    )
        .then(response => {
          dispatch(checkPermissionSuccess(response));
        }, err => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          dispatch(checkPermissionFailure(err));
        });
  }
}

function checkPermissionSuccess(data) {
  return {
    type: CHECK_PERMISSIOIN_SUCCESS,
    payload: data
  }
}

function checkPermissionFailure(error) {
  return {
    type: CHECK_PERMISSIOIN_FAILURE,
    payload: error
  }
}

function fetchActionLogSuccess(data) {
  return {
    type: FETCH_ACTION_LOG_SUCCESS,
    payload: data,
  };
}

function fetchActionLogFailure(error) {
  return {
    type: FETCH_ACTION_LOG_FAILURE,
    payload: error,
  };
}

export function fetchActionLog() {
  const url = `${ROOT_URL}v1/dashboard/audit_trail`;
  return (dispatch) => {
    dispatch({ type: REQUEST_ACTION_LOG });
    return axios({
      method: 'get',
      url,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      dispatch(fetchActionLogSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(fetchActionLogFailure(err));
    });
  };
}


export function fetchActionLogByFilter(action, field, days, fromDate, toDate) {
  const dates = toFromDates(days, fromDate, toDate);
  if (!field) {
    field = '';
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_ACTION_LOG_BY_FILTER});
    return axios.get(
      `${ACTION_LOG_FILTER_URL}?Action=${action}&Field=${field}&Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      dispatch(fetchActionLogByFilterSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR
      }
      dispatch(fetchActionLogByFilterFailure(err));
    });
  };
}

export function fetchActionLogByFilterSuccess(data) {
  return {
    type: ACTION_LOG_FILTER_SUCCESS,
    payload: data,
  };
}

export function fetchActionLogByFilterFailure(err) {
  return {
    type: ACTION_LOG_FILTER_FAILURE,
    payload: err,
  };
}

export function grabMobileUserID(id) {
  return {
    type: GRAB_MOBILE_USER_ID,
    payload: id
  }
}

export function fetchUsername(id) {
  return (dispatch) => {
    dispatch(requestUsername())
    return axios.get(`${USERNAME_URL}${id}/`, 
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      dispatch(requestUsernameSuccess(response.data))
    }, (err) => {
      dispatch(requestUsernameFailure(err));
    })
  }
}

export function requestUsername() {
  return {
    type: REQUEST_USERNAME
  };
}

export function requestUsernameSuccess(data) {
  return {
    type: REQUEST_USERNAME_SUCCESS,
    payload: data.username
  };
}

export function requestUsernameFailure(err) {
  return {
    type: REQUEST_USERNAME_FAILURE,
    payload: err
  };
}

export function clearUsernameData() {
  return {
    type: CLEAR_USERNAME_DATA
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/settings_actions.jsx